// extracted by mini-css-extract-plugin
export default {"eventsContainer":"PlayerProfileEventsPage_eventsContainer__qg2bl"};